import { ShareEntity } from '../types/ShareEntity'
import ApiBase from './Api'

const SHARE_API_PATHS = {
    SHARES: '/shares',
    SHARES_ADMIN: '/admin/shares',
}

class ShareApi extends ApiBase {
    async findAll(): Promise<ShareEntity[]> {
        const fetchedShares = await this._getRequest(SHARE_API_PATHS.SHARES)

        return fetchedShares as ShareEntity[]
    }
    async findByCompanyId(companyId: string): Promise<ShareEntity[]> {
        if (!companyId) {
            return []
        }
        const fetchedShares = await this._getRequest(SHARE_API_PATHS.SHARES, {
            queryParameters: { companyId },
        })

        return fetchedShares as ShareEntity[]
    }
}

export default ShareApi
